module.exports = __webpack_public_path__ + "static/media/7.567e47d7.PNG";